import { useRouter } from "next/router";
import { withApolloSSR } from "@/shared/utils/withApolloSSR";
import { StreamScreen } from "@/widgets/StreamScreen";

// Полная страница стрима — только для прямых заходов (SEO, шаринг, F5).
// Клики по ссылкам на /stream/... на этот роут вообще не попадают: они меняют
// URL сырой записью в историю мимо Next-роутера (см. openRouteDialog), а
// StreamScreen рендерится в route-диалоге поверх текущей страницы (_app).
const StreamPage = () => {
  const router = useRouter();
  const id = router.query.id as string;

  return <StreamScreen id={id} />;
};

export const getServerSideProps = withApolloSSR(StreamPage);
export default StreamPage;
